import { CANVAS_FONT_FAMILY } from "./fonts";
import { koTimeline, endTransition } from "../ui/ko";
import { pill, outlinedText } from "./canvas-shapes";
export function drawEndOverlay(
  c: CanvasRenderingContext2D,
  width: number,
  height: number,
  t: number,
  ko: boolean,
  reduced: boolean,
): void {
  const m = koTimeline(t, reduced),
    wipe = endTransition(t, ko, reduced);
  if (ko && m.flash > 0) {
    c.fillStyle = `rgba(255,255,255,${m.flash})`;
    c.fillRect(0, 0, width, height);
  }
  if (ko && m.stampAlpha > 0) {
    c.save();
    c.globalAlpha = m.stampAlpha;
    if (reduced) {
      c.fillStyle = "#2A244088";
      c.fillRect(0, 0, width, height);
      pill(
        c,
        { x: width / 2 - 140, y: height * 0.421 - 60, width: 280, height: 120 },
        "#FFFFFF",
        "#EDE9FF",
        22,
      );
    }
    c.translate(width / 2, height * 0.421);
    // Keep the stamp at 52 screen pt throughout the KO hold.
    c.font = `700 52px ${CANVAS_FONT_FAMILY}`;
    c.textAlign = "center";
    c.textBaseline = "middle";
    const metrics = c.measureText("K.O.!");
    c.translate(
      (metrics.actualBoundingBoxLeft - metrics.actualBoundingBoxRight) / 2,
      (metrics.actualBoundingBoxAscent - metrics.actualBoundingBoxDescent) / 2,
    );
    outlinedText(c, "K.O.!", 0, 0, 52, "#FFD23F", "#2A2440", 3);
    c.restore();
  }
  if (wipe.mode === "none") return;
  c.save();
  c.fillStyle = "#FFFFFF";
  if (wipe.mode === "fade") {
    c.globalAlpha = wipe.alpha;
    c.fillRect(0, 0, width, height);
  } else if (wipe.mode === "hold") c.fillRect(0, 0, width, height);
  else {
    const edge =
      wipe.mode === "close"
        ? height + 140 - (height + 420) * wipe.progress
        : (height + 280) * (1 - wipe.progress) - 140;
    if (wipe.mode === "close") c.fillRect(0, edge, width, height - edge + 280);
    else c.fillRect(0, -280, width, Math.max(0, edge + 280));
    for (let i = 0; i < 14; i++) {
      const r = 60 + ((i * 37) % 81);
      c.beginPath();
      c.arc((i * width) / 13, edge + (i % 2 ? 12 : -8), r, 0, Math.PI * 2);
      c.fill();
    }
  }
  c.restore();
}
